/**
 * Типографские знаки интерфейса из прототипа (не переводимый текст): стрелки пагинации,
 * каретки сортировки, знак обязательного поля и т.п. У интерактивных элементов с такими
 * знаками доступное имя задаётся через t() (aria-label).
 */
export const GLYPH = {
  required: '∗',
  close: '✕',
  prev: '‹',
  next: '›',
  sortAsc: '▲',
  sortDesc: '▼',
  sortNone: '↕',
  caretDown: '▼',
  check: '✓',
  plus: '+',
  ellipsis: '…',
  /** Нет значения в ячейке (длительность при таймауте, ответ без кода). */
  dash: '—',
  slash: '/',
  middot: '·',
  /** Пустая миниатюра изображения (прототип: «▣»). */
  square: '▣',
  /** Миниатюра видео (прототип медиа: «▶»). */
  play: '▶',
  /** «Убрать строку» в полях-списках (прототип: «×»). */
  times: '×',
  /** Порядок строк: выше / ниже. */
  up: '↑',
  down: '↓',
  /** «Ключ → значение» (пары настроек интеграции). */
  arrow: '→',
} as const;
